<template>
	<div>
		<div class="d-flex flex-wrap align-items-center gap-2 mb-2">
			<span
				class="badge rounded-pill"
				:class="open ? 'bg-warning text-dark' : 'bg-secondary'"
			>
				{{ open ? "Awaiting collection" : "Collected" }}
			</span>
			<span
				v-if="trap.trap_type"
				class="badge rounded-pill bg-light text-dark border"
			>
				{{ trap.trap_type }}
			</span>
			<span
				v-if="trap.lure"
				class="badge rounded-pill bg-light text-dark border"
			>
				Lure {{ trap.lure }}
			</span>
		</div>

		<dl class="row row-cols-1 row-cols-md-2 g-2 mb-0 small">
			<div class="col">
				<dt class="text-body-secondary fw-normal">Site</dt>
				<dd class="mb-0">{{ trap.site || `Site #${trap.site_id}` }}</dd>
			</div>
			<div class="col">
				<dt class="text-body-secondary fw-normal">Station</dt>
				<dd class="mb-0">{{ trap.station || "Off-station" }}</dd>
			</div>
			<div class="col">
				<dt class="text-body-secondary fw-normal">Set</dt>
				<dd class="mb-0">{{ formatDate(new Date(trap.date)) }}</dd>
			</div>
			<div class="col">
				<dt class="text-body-secondary fw-normal">Collected</dt>
				<dd class="mb-0">
					{{
						trap.collected_at
							? formatDate(new Date(trap.collected_at))
							: "Still out"
					}}
				</dd>
			</div>
			<div class="col">
				<dt class="text-body-secondary fw-normal">Interval</dt>
				<dd class="mb-0">
					{{ trap.interval === null ? "—" : `${trap.interval} days` }}
				</dd>
			</div>
			<div class="col">
				<dt class="text-body-secondary fw-normal">Position</dt>
				<dd class="mb-0">
					{{
						trap.latitude !== null && trap.longitude !== null
							? `${trap.latitude}, ${trap.longitude}`
							: "No point recorded"
					}}
				</dd>
			</div>
		</dl>

		<div v-if="open" class="mt-3">
			<button
				type="button"
				class="btn btn-sm btn-primary"
				@click="emit('collect', trap)"
			>
				<i class="bi bi-inboxes me-1"></i>Create collect_trap assignment
			</button>
			<p class="form-text mb-0">
				This pre-fills the assignment form with this instance; nothing is
				created until you choose a technician and submit.
			</p>
		</div>
		<p v-else class="text-body-secondary small mb-0 mt-3">
			This trap has been collected. Its instance remains the record the
			completion gate measured the collecting assignment against.
		</p>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { formatDate } from "@/format";
import type { MapReviewTrapInstanceRow } from "@/type/api";

const props = defineProps<{ trap: MapReviewTrapInstanceRow }>();

const emit = defineEmits<{ collect: [trap: MapReviewTrapInstanceRow] }>();

const open = computed(() => props.trap.collected_at === null);
</script>
